import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ErrorType } from '../../api/errorHandling';

export interface HistoryType {
 Id: number;
 Date: string;
 Column: string;
 Model: string;
 ActionId: number;
 MainRecordId: number;
 ChangeFrom: string;
 ChangeTo: string;
 Comment: string;
}

interface HistoryState {
 history: HistoryType[];
 loading?: { [key: string]: boolean | null };
 success?: { [key: string]: boolean | null };
}

export interface GetHistoryPayload {
 model: string;
 id: number;
}
export const initialState: HistoryState = {
 history: [],
 loading: {},
 success: {},
};

const HistorySlice = createSlice({
 name: 'History',
 initialState,
 reducers: {
  getHistoryStart(state, action: PayloadAction<GetHistoryPayload>) {
   return {
    ...state,
    loading: { ...state.loading, getHistory: true },
   };
  },
  getHistorySuccess(state, action: PayloadAction<HistoryState>) {
   return {
    ...state,
    history: action.payload.history,
    success: { ...state.success, getHistory: true },
    loading: { ...state.loading, getHistory: null },
   };
  },
  getHistoryFailure(state, action: PayloadAction<ErrorType>) {
   return {
    ...state,
    success: { ...state.success, getHistory: false },
    loading: { ...state.loading, getHistory: null },
   };
  },
 },
});
export const { getHistoryStart, getHistorySuccess, getHistoryFailure } =
 HistorySlice.actions;
export default HistorySlice.reducer;
